import React, { Component } from "react";
import PropTypes from "prop-types";
import QRCode from "qrcode.react";

// https://www.europeanpaymentscouncil.eu/document-library/guidance-documents/quick-response-code-guidelines-enable-data-capture-initiation

const charactersets = {
  UTF_8: 1,
  ISO8859_1: 2,
  ISO8859_2: 3,
  ISO8859_4: 4,
  ISO8859_5: 5,
  ISO8859_7: 6,
  ISO8859_10: 7,
  ISO8859_15: 8
};
export default class componentName extends Component {
  static propTypes = {
    bic: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    iban: PropTypes.string.isRequired,
    amount: PropTypes.number.isRequired,
    purpose: PropTypes.string,
    remittancereference: PropTypes.string,
    remittancetext: PropTypes.string,
    information: PropTypes.string,
    version: PropTypes.number,
    characterset: PropTypes.string,
    size: PropTypes.number,
  };

  render() {
    const {
      bic,
      name,
      iban,
      amount,
      purpose = "",
      remittancereference,
      remittancetext = "",
      information = "",
      version=2,
      characterset,
      size,
    } = this.props;

    const sepa = [
      "BCD",
      version.toString().padStart(3, "0"),
      characterset && charactersets.hasOwnProperty(characterset.uppercase())
        ? charactersets[characterset.uppercase()]
        : "1",
      "SCT",
      bic,
      name,
      iban,
      "EUR" + parseInt(amount,10).toFixed(2),
      purpose,
      remittancereference ? remittancereference : remittancetext,
      information
    ];

    return (
      <div>
        <QRCode value={sepa.join("\n")} size={size}/>
      </div>
    );
  }
}
